import { useMutation } from 'react-query';
import {
  createActiveSoftIntegrationAsync,
  deleteActiveSoftIntegrationAsync,
  getAllActiveSoftIntegrationsAsync,
  getActiveSoftIntegrationByIdAsync,
  updateActiveSoftIntegrationAsync,
} from '../../index';

export const useCreateActiveSoftIntegrationAsync = () =>
  useMutation(createActiveSoftIntegrationAsync);

export const useGetActiveSoftIntegrationByIdAsync = () =>
  useMutation(getActiveSoftIntegrationByIdAsync);

export const useGetAllActiveSoftIntegrationsAsync = () =>
  useMutation(getAllActiveSoftIntegrationsAsync);

export const useUpdateActiveSoftIntegrationAsync = () =>
  useMutation(updateActiveSoftIntegrationAsync);

export const useDeleteActiveSoftIntegrationAsync = () =>
  useMutation(deleteActiveSoftIntegrationAsync);
